//@ts-check
import axios from 'api/axios'
import { useEffect, useState } from 'react'

/**
 * @module FetchHooks
 */

/**
 * Hook that fetch the my_users_data
 * @returns {import('common/types/connections_types').UseFetchHookResponse<Array<InformeMenu>>}
 */
const useFetchInformesMenu = () => {
  const [response, setResponse] = useState()
  const [error, setError] = useState()
  const [loading, setLoading] = useState(false)

  const fetchData = () => {
    if (loading) {
      return
    }
    setLoading(true)
    axios
      .get(`/informes/menus`)
      .then((/**@type {import('axios').AxiosResponse<Array<InformeMenu>>}*/ request_response) => {
        const data = request_response.data
        setResponse(data)
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (!loading) fetchData()
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { response, error, loading }
}

export default useFetchInformesMenu
